import Head from 'next/head';

const EirMetaTag = props => {
  const getMeta = meta => {
    const data = meta?.map(obj => {
      const newParams = {};
      obj.genericMeta.forEach(genericObj => {
        newParams[genericObj.Key] = genericObj.Value;
        return newParams;
      });
      return <meta {...newParams} />;
    });
    return data;
  };
  const getStructuredData = structuredData => (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );

  return (
    <Head>
      {props.seo?.gtmPagetype && <script>window.gtmPageType={props.seo?.gtmPagetype}</script>}
      {props.seo?.metaTitle && <title>{props.seo?.metaTitle}</title>}
      {props.seo?.metaTitle && <meta name='title' content={props.seo?.metaTitle} />}
      {props.seo?.metaDescription && (
        <meta name='description' content={props.seo?.metaDescription} />
      )}
      {props.seo?.metaRobots && <meta name='robots' content={props.seo?.metaRobots} />}
      {props.seo?.keywords && <meta name='keywords' content={props.seo?.keywords} />}
      {props.seo?.canonicalURL && <link rel='canonical' href={props.seo?.canonicalURL} />}
      {props.seo?.metaViewport && <meta name='viewport' content={props.seo?.metaViewport} />}
      {getMeta(props?.seo && props.seo.Meta)}
      {props.seo?.structuredData && getStructuredData(props.seo?.structuredData)}
    </Head>
  );
};

export default EirMetaTag;
